const accessToAllN4 = ['Chief', 'Admin', 'Viewer', 'Nave4Viewer'];
const cleaningAccess = ['Nave4Cleaning', 'Nave4Leader', 'Nave4Supervisor'];
const qcAccess = ['Nave4QC', 'QualityControl', 'QualityControlInspector'];
const accessToAll = [
  'Chief',
  'Admin',
  'Viewer',
  'Nave4Viewer',
  'Nave4Admin',
  'Nave4Chief',
];
export const nave4AccionesRoles = {
  sharedActions: {
    scheduler: [...accessToAll, 'Nave4Operator', 'Nave4Leader'],
    qcData: [
      'Chief',
      'Admin',
      'Viewer',
      'Nave4Admin',
      'Nave4Chief',
      'QualityControl',
    ],
    qualityControl: [
      'Chief',
      'Admin',
      'Viewer',
      'Nave4Admin',
      'Nave4Chief',
      ...qcAccess,
    ],
    validation: [...accessToAll, 'Nave4Leader', 'Nave4Cleaning'],
    cleaning: [...accessToAll, ...cleaningAccess],
    packingBox: [
      'Chief',
      'Admin',
      'Viewer',
      'Nave4Admin',
      'Nave4Chief',
      'Nave4Viewer',
      'Nave4Supervisor',
      'QualityControl',
      'QualityControlInspector',
      'LabelOperator',
      'Nave4Label',
    ],
  },

  routerActions: {
    // No hay rutas exclusivas del router
  },

  sideNavActions: {
    root: [...accessToAllN4, 'Nave4Operator', 'Nave4Leader', 'Nave4Cleaning'],
    reportsPbiNave4: [...accessToAllN4, 'Nave4Operator', 'Nave4Leader'],
  },
};
